import { ShieldCheckIcon } from 'lucide-react';

import { routes } from '@workspace/routes';
import {
  FacebookIcon,
  InstagramIcon,
  TikTokIcon
} from '@workspace/ui/components/brand-icons';

export const MENU_LINKS = [
  {
    title: 'Colecția noastră',
    items: [
      {
        title: 'Platinum',
        description: 'Colecția supremă - vehicule de lux exclusiviste',
        image: '/assets/hero/hero.webp',
        href: `${routes.marketing.Cars}?categorie=platinum`,
        external: false
      },
      {
        title: 'Gold',
        description: 'Clasa premium - performanță și rafinament',
        image: '/assets/cars/cars-3.jpg',
        href: `${routes.marketing.Cars}?categorie=gold`,
        external: false
      },
      {
        title: 'Silver',
        description: 'Categoria selectă - confort și eleganță',
        image: '/assets/cars/cars-1.jpg',
        href: `${routes.marketing.Cars}?categorie=silver`,
        external: false
      },
      {
        title: 'Colecția completă',
        description: 'Toate vehiculele noastre de lux disponibile',
        image: '/assets/cars/cars-2.jpg',
        href: routes.marketing.Cars,
        external: false
      }
    ]
  },
  {
    title: 'Servicii',
    items: [
      {
        title: 'Mașină decontată prin RCA',
        description:
          'Autoturism de schimb decontat prin RCA pe durata reparației',
        icon: <ShieldCheckIcon className="size-5 shrink-0" />,
        href: routes.marketing.services.RcaReplacement,
        external: false
      }
      // {
      //   title: 'Contact',
      //   description: 'Serviciul nostru dedicat vă stă la dispoziție',
      //   icon: <SendHorizonalIcon className="size-5 shrink-0" />,
      //   href: routes.marketing.Contact,
      //   external: false
      // }
    ]
  },
  {
    title: 'Blog',
    href: routes.marketing.Blog,
    external: false
  },
  {
    title: 'Despre noi',
    href: routes.marketing.Story,
    external: false
  }
];

export const FOOTER_LINKS = [
  {
    title: 'Automobile',
    links: [
      {
        name: 'Platinum',
        href: `${routes.marketing.Cars}?categorie=platinum`,
        external: false
      },
      {
        name: 'Gold',
        href: `${routes.marketing.Cars}?categorie=gold`,
        external: false
      },
      {
        name: 'Silver',
        href: `${routes.marketing.Cars}?categorie=silver`,
        external: false
      },
      {
        name: 'Colecția completă',
        href: routes.marketing.Cars,
        external: false
      }
    ]
  },
  {
    title: 'Servicii',
    links: [
      {
        name: 'Mașină decontată prin RCA',
        href: routes.marketing.services.RcaReplacement,
        external: false
      }
      // { name: 'Contact', href: routes.marketing.Contact, external: false }
    ]
  },
  {
    title: 'Companie',
    links: [
      {
        name: 'Despre noi',
        href: routes.marketing.Story,
        external: false
      },
      { name: 'Blog', href: routes.marketing.Blog, external: false },
      {
        name: 'Termeni și condiții',
        href: routes.marketing.TermsOfUse,
        external: false
      }
    ]
  }
  // {
  //   title: 'Legal',
  //   links: [
  //     {
  //       name: 'Termeni și condiții',
  //       href: routes.marketing.TermsOfUse,
  //       external: false
  //     },
  //     {
  //       name: 'Politica de confidențialitate',
  //       href: routes.marketing.PrivacyPolicy,
  //       external: false
  //     },
  //     {
  //       name: 'Politica de cookies',
  //       href: routes.marketing.CookiePolicy,
  //       external: false
  //     }
  //   ]
  // }
];

export const SOCIAL_LINKS = [
  {
    name: 'Facebook',
    href: '#',
    icon: <FacebookIcon className="size-4 shrink-0" />
  },
  {
    name: 'Instagram',
    href: '#',
    icon: <InstagramIcon className="size-4 shrink-0" />
  },
  {
    name: 'TikTok',
    href: '#',
    icon: <TikTokIcon className="size-4 shrink-0" />
  }
];
